<template>
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="31" fill="white" stroke="currentColor" />
    <path
      d="M26.79 27C26.79 26.4477 26.3423 26 25.79 26H20.5L20.3834 26.0067C19.886 26.0645 19.5 26.4872 19.5 27C19.5 27.5523 19.9477 28 20.5 28H25.79L25.9067 27.9933C26.404 27.9355 26.79 27.5128 26.79 27Z"
      fill="currentColor"
    />
    <path
      d="M32.355 31C32.355 30.4477 31.9073 30 31.355 30H20.5L20.3834 30.0067C19.886 30.0645 19.5 30.4872 19.5 31C19.5 31.5523 19.9477 32 20.5 32H31.355L31.4716 31.9933C31.9689 31.9355 32.355 31.5128 32.355 31Z"
      fill="currentColor"
    />
    <path
      d="M31.355 34C31.9073 34 32.355 34.4477 32.355 35C32.355 35.5128 31.9689 35.9355 31.4716 35.9933L31.355 36H20.5C19.9477 36 19.5 35.5523 19.5 35C19.5 34.4872 19.886 34.0645 20.3834 34.0067L20.5 34H31.355Z"
      fill="currentColor"
    />
    <path
      d="M32.355 39C32.355 38.4477 31.9073 38 31.355 38H20.5L20.3834 38.0067C19.886 38.0645 19.5 38.4872 19.5 39C19.5 39.5523 19.9477 40 20.5 40H31.355L31.4716 39.9933C31.9689 39.9355 32.355 39.5128 32.355 39Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31 17C31.0244 17 31.0487 17.0009 31.0727 17.0026C31.3178 16.9849 31.5679 17.0573 31.7695 17.2188L31.8625 17.3034L36.7174 22.3034C36.9713 22.5649 37.0536 22.9295 36.9663 23.2579C36.9883 23.3402 37 23.4268 37 23.5161V46C37 46.5523 36.5523 47 36 47H16C15.4477 47 15 46.5523 15 46V18C15 17.4477 15.4477 17 16 17H31ZM32 20.316L34.1363 22.5161H32V20.316ZM17 19H30V22.5161L30.0055 22.6654C30.0818 23.7002 30.9456 24.5161 32 24.5161L35 24.516V45H17V19Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47 18C47 17.4477 46.5523 17 46 17H41C40.4477 17 40 17.4477 40 18V39L40.0777 39.3672C41.167 44.4478 42.3078 46.9882 43.5 46.9882C44.6638 46.9882 45.7786 44.5674 46.8444 39.7258L47 39V18ZM42 19H45V21H42V19ZM42 23H45V38.787L44.9553 39H42.0445C42.0407 38.9827 42.037 38.9653 42.0333 38.948L42 38.792V23ZM42.5125 41C42.8099 42.1609 43.1062 43.1102 43.3968 43.8416L43.499 44.091L43.5501 43.9729C43.8583 43.2238 44.1723 42.2304 44.4875 41H42.5125Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HelpWithHomework',
};
</script>
